import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FilterControl } from '../../../interfaces/filter-control';
import { FilterControlParams } from '../../../interfaces/filter-control-params';
import { FormControl } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'bm-daterange-filter',
  templateUrl: './daterange-filter.component.html',
  styleUrls: ['./daterange-filter.component.scss']
})
export class DaterangeFilterComponent implements FilterControl, OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() control: FilterControlParams;

  dateStart = new FormControl('');
  dateEnd = new FormControl('');


  public datepickerConfig: Partial<BsDatepickerConfig> = {
    containerClass: 'theme-default',
    showWeekNumbers: false,
  };

  constructor() {
  }

  today = new Date();

  ngOnInit() {
    this.control.value = {
      start: null,
      end: null
    };

    this.dateStart.valueChanges.subscribe(date => {
      this.control.value.start = date;
    });

    this.dateEnd.valueChanges.subscribe(date => {
      this.control.value.end = date;
    });

    if (this.control.compactValue) {
      if (this.control.compactValue.start) {
        this.dateStart.setValue(moment(this.control.compactValue.start).toDate());
      }
      if (this.control.compactValue.end) {
        this.dateEnd.setValue(moment(this.control.compactValue.end).toDate());
      }
    }




  }


}
